import { formatDate } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TransactionModel } from "src/app/const/transaction-model.enum";

export enum TransactionStatus {
  ALL = 0,
  PANDING = 1,
  SUCCESS = 2,
  FAILED = 3,
  REJECTEDBYCUSTOMER = 4,
  REJECTEDBYMERCHANT = 5,
}

export interface IFilterData {
  fromDate?: any;
  endDate?: any;
  status?: number | string;
}

@Component({
  selector: "app-filter",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"],
})
export class FilterComponent implements OnInit {
  @Input() transactionModel;
  @Input() filterData: IFilterData;
  @Input() isStatusEnabled: boolean;

  currentStatus: any = [];
  couponStatus: any = [];
  wayyakStatus = [
    {
      name: "All",
      val: TransactionStatus.ALL,
      active: false,
      color: "dark",
    },
    {
      name: "Accepted",
      val: TransactionStatus.SUCCESS,
      active: false,
      color: "success",
    },
    {
      name: "Rejected",
      val: TransactionStatus.FAILED,
      active: false,
      color: "danger",
    },
    {
      name: "Pending",
      val: TransactionStatus.PANDING,
      active: false,
      color: "warning",
    },
  ];

  transactionStatus = [
    {
      name: "All",
      val: TransactionStatus.ALL,
      active: false,
      color: "dark",
    },
    {
      name: "Success",
      val: TransactionStatus.SUCCESS,
      active: false,
      color: "success",
    },
    {
      name: "Failed",
      val: TransactionStatus.FAILED,
      active: false,
      color: "danger",
    },
    {
      name: "Pending",
      val: TransactionStatus.PANDING,
      active: false,
      color: "warning",
    },
    {
      name: "Rejected by customer",
      val: TransactionStatus.REJECTEDBYCUSTOMER,
      active: false,
      color: "danger",
    },
  ];

  paymentLinkStatus = [
    { name: "All", val: "", active: false, color: "dark" },
    {
      name: "Paid",
      val: "paid",
      active: false,
      color: "success",
    },
    {
      name: "Cancelled",
      val: "cancelled",
      active: false,
      color: "danger",
    },
    {
      name: "Pending",
      val: "unpaid",
      active: false,
      color: "warning",
    },
    {
      name: "Expired",
      val: "expired",
      active: false,
      color: "dark",
    },
  ];
  startDate: any;
  endDate: any;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    switch (this.transactionModel) {
      case TransactionModel.C2B:
        this.currentStatus = this.transactionStatus;
        this.applyTransactionFilterData();
        break;
      case TransactionModel.WAYYAK:
        this.currentStatus = this.wayyakStatus;
        this.applyWayyakFilterData();
        break;
      case TransactionModel.PAYMENTLINK:
        this.currentStatus = this.paymentLinkStatus;
        this.applyPaymentLinkFilterData();
        break;
      case TransactionModel.COUPON:
        this.currentStatus = this.couponStatus;
        this.applyPaymentLinkFilterData();
        break;
      default:
        this.currentStatus = [];
    }
  }

  applyCouponFilterData(): void {
    this.startDate = this.filterData.fromDate;
    this.endDate = this.filterData.endDate;
  }

  applyTransactionFilterData(): void {
    if (
      this.filterData &&
      this.filterData.status &&
      this.filterData.status !== ""
    ) {
      const state = this.transactionStatus.find(
        (st) => st.val === this.filterData.status
      );
      if (state) state.active = true;
    }
    this.startDate = this.filterData.fromDate;
    this.endDate = this.filterData.endDate;
  }

  applyWayyakFilterData(): void {
    if (
      this.filterData &&
      this.filterData.status &&
      this.filterData.status !== ""
    ) {
      const state = this.wayyakStatus.find(
        (st) => st.val === this.filterData.status
      );
      if (state) state.active = true;
    }
    this.startDate = this.filterData.fromDate;
    this.endDate = this.filterData.endDate;
  }

  applyPaymentLinkFilterData(): void {
    if (
      this.filterData &&
      this.filterData.status &&
      this.filterData.status !== ""
    ) {
      const state = this.paymentLinkStatus.find(
        (st) => st.val === this.filterData.status
      );
      if (state) state.active = true;
    }
    this.startDate = this.filterData.fromDate;
    this.endDate = this.filterData.endDate;
  }

  activateStatus(status): void {
    if (this.transactionModel === TransactionModel.WAYYAK) {
      this.wayyakStatus.forEach((item) => (item.active = false));
      const state = this.wayyakStatus.find((st) => st.name === status.name);
      state.active = true;
    }
    if (this.transactionModel === TransactionModel.PAYMENTLINK) {
      this.paymentLinkStatus.forEach((item) => (item.active = false));
      const state = this.paymentLinkStatus.find(
        (st) => st.name === status.name
      );
      state.active = true;
    }

    if (this.transactionModel === TransactionModel.C2B) {
      this.transactionStatus.forEach((item) => (item.active = false));
      const state = this.transactionStatus.find(
        (st) => st.name === status.name
      );
      state.active = true;
    }
  }

  applyFilter() {
    let status: any;
    if (this.transactionModel === TransactionModel.WAYYAK) {
      status = TransactionStatus.ALL;
      const state = this.wayyakStatus.find((st) => st.active === true);
      if (state) {
        status = state.val;
      }
    }

    if (this.transactionModel === TransactionModel.PAYMENTLINK) {
      status = "";
      const state = this.paymentLinkStatus.find((st) => st.active === true);
      if (state) {
        status = state.val;
      }
    }

    if (this.transactionModel === TransactionModel.C2B) {
      status = "";
      const state = this.transactionStatus.find((st) => st.active === true);
      if (state) {
        status = state.val;
      }
    }

    const filterData: IFilterData = {
      fromDate: !this.startDate ? "" : this.formatDate(this.startDate),
      endDate: !this.endDate ? "" : this.formatDate(this.endDate),
      status: status,
    };
    this.modalCtrl.dismiss(filterData);
  }

  closeModal(): void {
    const filterData: IFilterData = {
      fromDate: undefined,
      endDate: undefined,
      status: "",
    };
    this.modalCtrl.dismiss(filterData);
  }

  formatDate(date): string {
    const format = "yyyy/MM/dd hh:mm:ss a";
    const locale = "en-US";
    const formattedDate = formatDate(date, format, locale);
    return formattedDate;
  }

  startDateChange(): void {
    if (this.startDate) {
      const startDate = new Date(this.startDate);
      startDate.setHours(0, 0, 0);
      this.startDate = this.formatDate(startDate);
    }
  }

  endDateChange(): void {
    if (this.endDate) {
      const endDate = new Date(this.endDate);
      endDate.setHours(23, 59, 59);
      this.endDate = this.formatDate(endDate);
    }
  }

  clearStatus() {
    this.wayyakStatus.forEach((item) => (item.active = false));
    this.paymentLinkStatus.forEach((item) => (item.active = false));
    this.transactionStatus.forEach((item) => (item.active = false));
    this.couponStatus.forEach((item) => (item.active = false));
  }

  clearDate() {
    this.startDate = undefined;
    this.endDate = undefined;
  }
}
